import React from "react";

const ApplicationIcon = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7557 11.3323C23.0805 10.9933 23.6186 10.9818 23.9576 11.3065L25.0489 12.3521C25.7979 13.0696 25.8107 14.2627 25.0773 14.9961L23.9706 16.1028C23.6386 16.4348 23.1004 16.4348 22.7685 16.1028C22.4365 15.7709 22.4365 15.2327 22.7685 14.9008L23.8752 13.794C23.9347 13.7346 23.9336 13.6378 23.8729 13.5797L22.7815 12.5341C22.4425 12.2093 22.431 11.6713 22.7557 11.3323Z"
        fill="#17479E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6022 10.1046C22.0226 10.3136 22.194 10.8237 21.9851 11.2441L19.1192 17.0108C18.9103 17.4312 18.4001 17.6026 17.9797 17.3937C17.5593 17.1847 17.3879 16.6746 17.5968 16.2542L20.4627 10.4875C20.6716 10.0671 21.1818 9.89571 21.6022 10.1046Z"
        fill="#17479E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9961 21.1547C13.9961 20.6852 14.3767 20.3047 14.8461 20.3047H25.6534C26.1228 20.3047 26.5034 20.6852 26.5034 21.1547C26.5034 21.6241 26.1228 22.0047 25.6534 22.0047H14.8461C14.3767 22.0047 13.9961 21.6241 13.9961 21.1547Z"
        fill="#17479E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9961 24.3891C13.9961 23.9196 14.3767 23.5391 14.8461 23.5391H25.6534C26.1228 23.5391 26.5034 23.9196 26.5034 24.3891C26.5034 24.8585 26.1228 25.2391 25.6534 25.2391H14.8461C14.3767 25.2391 13.9961 24.8585 13.9961 24.3891Z"
        fill="#17479E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9961 27.7016C13.9961 27.2321 14.3767 26.8516 14.8461 26.8516H30.0831C30.5525 26.8516 30.9331 27.2321 30.9331 27.7016C30.9331 28.171 30.5525 28.5516 30.0831 28.5516H14.8461C14.3767 28.5516 13.9961 28.171 13.9961 27.7016Z"
        fill="#17479E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9961 31.0219C13.9961 30.5524 14.3767 30.1719 14.8461 30.1719H30.0831C30.5525 30.1719 30.9331 30.5524 30.9331 31.0219C30.9331 31.4913 30.5525 31.8719 30.0831 31.8719H14.8461C14.3767 31.8719 13.9961 31.4913 13.9961 31.0219Z"
        fill="#17479E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0312 5.84219C10.0312 3.71589 11.755 1.99219 13.8812 1.99219H31.1171C33.2434 1.99219 34.9671 3.71589 34.9671 5.84219V39.1547C34.9671 41.281 33.2434 43.0047 31.1171 43.0047H13.8812C11.755 43.0047 10.0312 41.281 10.0312 39.1547V5.84219ZM13.8812 3.69219C12.6938 3.69219 11.7313 4.65477 11.7313 5.84219V7.06528H33.2671V5.84219C33.2671 4.65477 32.3045 3.69219 31.1171 3.69219H13.8812ZM33.2671 8.76528H11.7313V35.9836H33.2671V8.76528ZM33.2671 37.6836H11.7313V39.1547C11.7313 40.3421 12.6938 41.3047 13.8812 41.3047H31.1171C32.3045 41.3047 33.2671 40.3421 33.2671 39.1547V37.6836Z"
        fill="#17479E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7871 11.3427C17.1191 11.6747 17.1191 12.2128 16.7871 12.5448L15.6971 13.6349C15.6385 13.6934 15.6385 13.7884 15.6971 13.847L16.5214 14.6713C16.8534 15.0033 16.8534 15.5415 16.5214 15.8734C16.1895 16.2054 15.6513 16.2054 15.3193 15.8734L14.495 15.0491C13.7725 14.3266 13.7725 13.1553 14.495 12.4328L15.5851 11.3427C15.917 11.0108 16.4552 11.0108 16.7871 11.3427Z"
        fill="#17479E"
      />
    </svg>
  );
};

export default ApplicationIcon;
